'use client';
const MANIFEST_ILLUSTRATIONS = {
    liveChat: {
        hashed: 'liveChat.20633ec8d0133af7a26496a150bb311e.svg',
        versioned: 'liveChat.svg'
    },
    generic: {
        hashed: 'generic.f1f362f7c606d59ebfa6959120362279.svg',
        versioned: 'generic.svg'
    }
};

export { MANIFEST_ILLUSTRATIONS };
